import { List } from 'immutable';
import { subscriptionFeeConstants } from '../constants';

export function subscription_fees(state = {}, action) {
  switch (action.type) {
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case subscriptionFeeConstants.SUBSCRIPTION_FEE_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case subscriptionFeeConstants.SUBSCRIPTION_FEE_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case subscriptionFeeConstants.SUBSCRIPTION_FEE_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const subscriptionFeeIndex = state.items.findIndex(val => val.id == action.response.id);

      if (subscriptionFeeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(subscriptionFeeIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case subscriptionFeeConstants.SUBSCRIPTION_FEE_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_DELETE_SUCCESS: {
      const subscriptionFeeId = action.feeId;

      if (!state.items) {
        return state;
      }

      const subscriptionFeeIndex = state.items.findIndex(val => val.id == subscriptionFeeId);

      if (subscriptionFeeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(subscriptionFeeIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case subscriptionFeeConstants.SUBSCRIPTION_FEE_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
